import Card from "../Card"
import SmallHeadingComponent from "../SmallHeadingComponent"
import { valueTypeNames } from "../../util/valueTypeNames"
import { useAppSelector } from "../../redux/store/hooks"
import {
    selectDashboardCurrentPatientData,
    selectDashboardSelectedPatient,
    selectDashboardSelectedValueType
} from "../../redux/ProfessionalDashboard"
import AggregatedDataView from "./chart/AggregatedDataView"
import notNull from "../../util/notNull"
import { useEffect, useState } from "react"
import {
    GetPatientDataCurrentResponsePayload,
    GetPatientsOfProfessionalResponsePayload,
    ValueType
} from "pokal_api"
import {
    hidePatientDetailViewDataCurrent,
    mockPatientUsed,
    mockPhqValueTypeUsed,
    mockSleepValueTypeUsed,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../../redux/Onboarding"
import {
    MOCK_PHQ_CURRENT_DATA,
    MOCK_SLEEP_CURRENT_DATA
} from "../../onboarding/mock/mockPatientData"
import { ArrayElement } from "../../types/ArrayElement"
import mockPatient from "../../onboarding/mock/mockPatient"
import DocumentationComponent from "../DocumentationComponent"
import ValueTypeDocumentation from "../../documentation/ValueTypeDocumentation"
import { CURRENT_DATA_DOC } from "../../documentation/Documentation"

function CurrentDataView() {
    const fetchedSelectedPatient = useAppSelector(
        selectDashboardSelectedPatient
    )
    const fetchedSelectedValueType = useAppSelector(
        selectDashboardSelectedValueType
    )
    const fetcheData = useAppSelector(selectDashboardCurrentPatientData)

    const [selectedValueType, setSelectedValueType] =
        useState<ValueType | null>(null)
    const [data, setData] =
        useState<GetPatientDataCurrentResponsePayload | null>(null)
    const [selectedPatient, setSelectedPatient] =
        useState<ArrayElement<GetPatientsOfProfessionalResponsePayload> | null>(
            null
        )

    const step = useAppSelector(selectOnboardingStep)
    const running = useAppSelector(selectOnboardingIsRunningState)

    useEffect(() => {
        if (mockPatientUsed(running, step)) {
            setSelectedPatient(mockPatient()[0])
            if (mockPhqValueTypeUsed(running, step)) {
                setData(MOCK_PHQ_CURRENT_DATA)
                setSelectedValueType(ValueType.PHQUESTIONNAIRE)
            }
            if (mockSleepValueTypeUsed(running, step)) {
                setData(MOCK_SLEEP_CURRENT_DATA)
                setSelectedValueType(ValueType.SLEEP_DURATION)
            }
        } else {
            setData(fetcheData)
            setSelectedValueType(fetchedSelectedValueType)
            setSelectedPatient(fetchedSelectedPatient)
        }
    }, [fetcheData, fetchedSelectedValueType, running, step])

    return (
        <>
            {notNull(data) &&
                notNull(selectedPatient) &&
                notNull(selectedValueType) && (
                    <Card
                        blur={hidePatientDetailViewDataCurrent(running, step)}
                        fill={true}
                        width={"100%"}>
                        <div className={"w-full flex flex-col space-y-4"}>
                            <SmallHeadingComponent>
                                Aktuelle Patient:innen-Daten
                            </SmallHeadingComponent>
                            <div>
                                <DocumentationComponent
                                    documentation={CURRENT_DATA_DOC}>
                                    Aktuelle Daten
                                </DocumentationComponent>{" "}
                                (d.h. Daten der letzten zwei Wochen) von
                                Patient:in {selectedPatient.firstName}{" "}
                                {selectedPatient.lastName} zur{" "}
                                <DocumentationComponent
                                    documentation={ValueTypeDocumentation(
                                        selectedValueType
                                    )}>
                                    {`Datenkategorie ${valueTypeNames[selectedValueType]}`}
                                </DocumentationComponent>
                            </div>
                            <AggregatedDataView dataType={"current"} />
                        </div>
                    </Card>
                )}
        </>
    )
}

export default CurrentDataView
